import { Component, Prop, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class ProductsCarousel extends ThemeComponent {
    @Ref carouselCard!: HTMLElement[];
    @Prop({ default: null }) recommended!: string;
    @Prop({ default: null }) cartconvert!: string;
    @Ref container!: HTMLElement;
    isMouseDown = false;
    startX = 0;
    startY = 0;
    startScrollLeft = 0;
    isDragging = false;
    clickThreshold = 10; // Adjust this threshold as needed
    cardWidth = 0; // Width of each card
    done = false;
    init() {
        if (this.cartconvert) {
            this.cartConvertRecs();
        } else if (this.recommended) {
            this.recommendedProducts();
        }
        this.initCarousel();
    }

    initCarousel() {
        this.addEventListener('mousedown', this.handleMouseDown.bind(this));
        this.addEventListener('mouseleave', this.handleMouseLeave.bind(this));
        this.addEventListener('mouseup', this.handleMouseUp.bind(this));
        this.addEventListener('mousemove', this.handleMouseMove.bind(this));
        this.addEventListener('click', this.handleClick.bind(this));

        for (const card of this.carouselCard) {
            if (card) {
                this.cardWidth = card.clientWidth;
            }
        }

    }

    handleMouseDown(e: MouseEvent) {
        this.isMouseDown = true;
        this.startX = e.pageX;
        this.startY = e.pageY;
        this.startScrollLeft = this.scrollLeft;
        this.style.scrollBehavior = 'unset';
        this.isDragging = false;
    }

    handleMouseLeave() {
        if (this.isMouseDown) {
            this.isMouseDown = false;
        }
    }

    handleMouseUp() {
        if (this.isMouseDown) {
            this.isMouseDown = false;
            this.style.scrollBehavior = 'smooth';
            this.snapToCard();
            this.classList.remove('grabbing'); // Remove the class here
        }
    }

    handleMouseMove(e: MouseEvent) {
        if (!this.isMouseDown) {
            return;
        }
        e.preventDefault();
        const moveX = e.pageX - this.startX;
        const moveY = e.pageY - this.startY;

        if (!this.isDragging && (Math.abs(moveX) > this.clickThreshold || Math.abs(moveY) > this.clickThreshold)) {
            this.isDragging = true;
        }

        if (this.isDragging) {
            const newScrollLeft = this.startScrollLeft - moveX;
            this.scrollLeft = newScrollLeft;
        }
    }

    handleClick(e: MouseEvent) {
        if (this.isDragging) {
            e.preventDefault();
            e.stopPropagation();
            this.classList.remove('grabbing');
        }
    }

    snapToCard() {
        const scrollPos = this.scrollLeft;
        const cardIndex = Math.round(scrollPos / this.cardWidth);
        const snappedPos = cardIndex * this.cardWidth;
        this.scrollTo({
            left: snappedPos,
            behavior: 'smooth',
        });
    }
    recommendedProducts() {
        fetch(this.recommended)
            .then((response) => response.text())
            .then((text) => {
                const html = document.createElement('div');
                html.innerHTML = text;
                const recommendations = html.querySelector('[data-ref="container"]');

                if (recommendations && recommendations.innerHTML.trim().length) {
                    this.container.innerHTML = recommendations.innerHTML;
                }
            })
            .catch((e) => {
                this.$log.warn('error', e);
            });
    }
    cartConvertRecs() {

        // Options for the observer (which mutations to observe)
        const config = { attributes: false, childList: true, subtree: true };

        // Callback function to execute when mutations are observed
        const callback = (mutationList: MutationRecord[], observer: MutationObserver) => {
            for (const mutation of mutationList) {
                if (this.done) { return; }
                const products = this.container.querySelectorAll('.esc_product') as unknown as HTMLElement[];
                if (products) {
                    this.getProducts(products);
                }
            }
        };

        // Create an observer instance linked to the callback function
        const observer = new MutationObserver(callback);

        // Start observing the target node for configured mutations
        observer.observe(this.container, config);

    }
    getProducts(prods: HTMLElement[]) {
        for (const prod of prods) {
            const url = prod.querySelector('a[href*="products"')?.getAttribute('href');
            if (!url) { return; }
            this.done = true;
            this.container.innerHTML = '';
            fetch(`${url}?section_id=product-card`)
                .then((response) => response.text())
                .then((text) => {
                    const dump = document.createElement('div');
                    dump.innerHTML = text;
                    const target = dump.querySelector('.product-card--carousel');
                    if (target) {
                        this.container.append(target);
                    }
                })
                .catch((e) => {
                    this.$log.warn('error', e);
                });
        }
    }
}
